import { jsx as t, jsxs as E } from "react/jsx-runtime";
import { ao as S, C as v, j as a, G as R, q as N, u as y, t as T, ap as I, S as x } from "./helpers-458d7e27.js";
import { T as O, i as A } from "./TextHeaderInner-7887aa3a.js";
import C from "clsx";
import { useState as k, useRef as w } from "react";
import "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "@paypalcorp/pp-react-icons";
import "react-dom";
import "./TextGroup-dd19925e.js";
import "./AppDownload-79ac7787.js";
import "./pp-react-text-input.esm-853a9847.js";
import "./card-renderer-3ad4b108.js";
import "./PpReactCurrencyInput-cfa9b61d.js";
const H = (o, e, r = !0) => {
  const [i, l] = k(r);
  return S(o, ([c]) => {
    typeof window < "u" && window.requestAnimationFrame(() => {
      var s;
      e.current && l(
        ((s = e.current) == null ? void 0 : s.clientWidth) > c.target.clientWidth
      );
    });
  }), i;
}, L = "LogoTickerSection", n = new v(L), h = "LogoTickerItem", W = {
  options: {
    columnStart: a.leftEdge,
    columnEnd: a.rightEdge
  },
  xlOptions: {
    columnStart: a.leftInner,
    columnEnd: a.rightInner
  }
}, D = 3, G = ({ logos: o }) => {
  const e = w(null), r = w(null), i = H(
    e,
    r
  ), l = C({
    [n.getElementClassName("logos-grid-static")]: !i,
    [n.getElementClassName("logos-grid")]: i
  }), m = C(
    n.getElementClassName("logos-slide-container"),
    {
      [n.getElementClassName("logos-slide-hidden")]: !i
    }
  ), c = (s) => {
    if (!e.current)
      return;
    const u = s.target, d = e.current, p = u.getBoundingClientRect(), f = e.current.getBoundingClientRect();
    if (p.left < f.left) {
      d.scrollLeft += p.left - f.left;
      return;
    }
    p.right > f.right && (d.scrollLeft += p.right - f.right);
  }, g = (s) => {
    s.preventDefault();
  };
  return /* @__PURE__ */ t(R, { ...W, className: l, children: /* @__PURE__ */ E(
    "div",
    {
      className: n.getElementClassName("logos-container"),
      ref: e,
      children: [
        /* @__PURE__ */ t(
          "div",
          {
            className: n.getElementClassName("logos-slide-container"),
            ref: r,
            children: /* @__PURE__ */ t("div", { className: n.getElementClassName("logos-slide"), children: o.map((s) => /* @__PURE__ */ t(
              "div",
              {
                className: n.getElementClassName("image-container"),
                onFocus: c,
                children: /* @__PURE__ */ t(
                  N,
                  {
                    ...s,
                    className: n.getElementClassName("image-frame"),
                    dimensions: { minHeight: "auto", minWidth: "auto" },
                    isAnimated: !1,
                    imageLinkAttrs: { onMouseDown: g },
                    loading: "eager",
                    analyticsCompName: h
                  },
                  s.imageAltText
                )
              },
              `image-container-${s.imageAltText}`
            )) })
          }
        ),
        [...Array(D)].map((s, u) => /* @__PURE__ */ t(
          "div",
          {
            className: m,
            children: /* @__PURE__ */ t("div", { className: n.getElementClassName("logos-slide"), children: o.map((d) => /* @__PURE__ */ t(
              N,
              {
                ...d,
                loading: "eager",
                className: n.getElementClassName("image-frame"),
                dimensions: { minHeight: "auto", minWidth: "auto" },
                isAnimated: !1,
                ariaHidden: !0,
                imageLinkAttrs: {
                  tabIndex: -1,
                  onMouseDown: g,
                  "aria-hidden": !0
                },
                analyticsCompName: h
              },
              `${d.imageAltText}-copy-${u + 1}`
            )) })
          },
          `logo-slide-container-copy-${u + 1}`
        ))
      ]
    }
  ) });
}, M = {
  xs: 2,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5,
  "2xl": 7
}, P = {
  options: {
    columnStart: a.leftInner,
    columnEnd: a.rightInner
  },
  lgOptions: {
    columnStart: a.leftInner,
    columnEnd: a.rightInner
  }
};
const $ = ({ logos: o }) => {
  const { viewportType: e } = y(), i = 100 / M[e], l = {
    flex: `1 1 ${i}%`,
    maxWidth: `${i}%`
  };
  return /* @__PURE__ */ t(R, { ...P, children: /* @__PURE__ */ t(
    "div",
    {
      className: n.getElementClassName("reduced-motion-container"),
      children: o.map((m) => /* @__PURE__ */ t("div", { style: l, children: /* @__PURE__ */ t(
        N,
        {
          ...m,
          className: n.getElementClassName(
            "reduced-motion-image-frame"
          ),
          dimensions: { minHeight: "auto", minWidth: "auto" },
          isAnimated: !1,
          analyticsCompName: h
        }
      ) }, m.imageAltText))
    }
  ) });
};
const F = (o) => {
  let e = o;
  return A(o) || (e = {
    textGroup: o
  }), /* @__PURE__ */ t(
    O,
    {
      className: n.getElementClassName("headline"),
      ...e
    }
  );
}, _ = ({
  collection: o,
  headline: e,
  disclosureType: r,
  topSpacer: i = "4vw",
  bottomSpacer: l = "4vw",
  theme: m = "white"
}) => {
  const c = T();
  return /* @__PURE__ */ t(
    I,
    {
      containerDimensions: {
        minHeight: "auto"
      },
      children: /* @__PURE__ */ E(
        x,
        {
          disclosure: r,
          options: { topSpacing: i, bottomSpacing: l },
          disclosureGridItemProps: {
            options: { topSpacing: "0vw" }
          },
          className: n.getComponentClassName(),
          theme: m,
          children: [
            e && F(e),
            c ? /* @__PURE__ */ t($, { logos: o }) : /* @__PURE__ */ t(G, { logos: o })
          ]
        }
      )
    }
  );
};
_.displayName = L;
export {
  _ as default
};
//# sourceMappingURL=LogoTickerSection.js.map
